export interface ElvaPageDataAttachment {
  title?: string;
  pageUrl: string;
  data: unknown;
}

export const ELVA_CHAT_OPEN_WITH_PAGE_DATA_EVENT =
  'elva-chat:open-with-page-data';

export const ELVA_CHAT_OPEN_EVENT = 'elva-chat:open';
export const ELVA_CHAT_CLOSE_EVENT = 'elva-chat:close';

export function openElvaChatWithPageData(attachment: ElvaPageDataAttachment) {
  window.dispatchEvent(
    new CustomEvent<ElvaPageDataAttachment>(
      ELVA_CHAT_OPEN_WITH_PAGE_DATA_EVENT,
      { detail: attachment },
    ),
  );
}

export function openElvaChat() {
  window.dispatchEvent(new CustomEvent(ELVA_CHAT_OPEN_EVENT));
}

export function closeElvaChat() {
  window.dispatchEvent(new CustomEvent(ELVA_CHAT_CLOSE_EVENT));
}
